<div class="itsl-container-with-gap {cssClass}">
    <slot></slot>
</div>
<script>
    export let cssClass = '';
</script>